import Login from "./features/auth/pages/Login";
import companyDomain from "./features/auth/pages/CompanyDomain";
import RecoverCompanyUrl from "./features/auth/pages/RecoverCompanyUrl";
import UserList from './features/users/pages/List';
import UserCreate from './features/users/pages/Create';
import UserShow from './features/users/pages/Show';
import UserUpdate from './features/users/pages/Update';
import Building from "./common/Layout/building";
import CompanyDashboard from "./features/company/pages/Dashboard";
import CompanyProfile from "./features/company/pages/Profile";
import EquipmentsList from "./features/equipments/screens/List";
import CompanyContract from "./features/company/pages/Contract";
import EquipmentsCreate from "./features/equipments/screens/Create";
import EquipmentsShow from "./features/equipments/screens/Show";
import EquipmentsUpdate from "./features/equipments/screens/Update";
import BillingBillsList from "./features/billingBills/pages/List";
import BillingEventsList from "./features/billingEvents/pages/List";
import CompanyBranchesStructure from "./features/companyBranches/pages/Structure";
import CompanyBranchesCreate from "./features/companyBranches/pages/Create";
import CompanyBranchesShow from "./features/companyBranches/pages/Show";
import CompanyBranchesUpdate from "./features/companyBranches/pages/Update";
import EstablishmentsMap from "./features/establishments/pages/Map";
import FailedConsumptionsList from "./features/failedConsumptions/pages/List";
import MovementsTotalizerList from "./features/movementsTotalizer/pages/List";
import EquipmentsChangeHistoryShow from "./features/equipments/screens/ChangeHistoryShow";
import UserActionsHistoryShow from "./features/users/pages/ActionsHistoryShow";
import SupportList from "./features/support/pages/List";
import SupportCreate from "./features/support/pages/Create";
import SupportShow from "./features/support/pages/Show";
import GovernmentAllocationList from "./features/governmentAllocations/pages/List";
import GovernmentAllocationUpdate from "./features/governmentAllocations/pages/Update";
import GovernmentAllocationShow from "./features/governmentAllocations/pages/Show";
import SupplyAuthorizationsList from "./features/supplyAuthorizations/pages/List";
import SupplyAuthorizationsShow from "./features/supplyAuthorizations/pages/Show";
import ResetPassword from "./features/auth/pages/ResetPassword";
import BillingEventsWithFiscalDocumentRequirementList from "./features/billing/pages/EventsWithFiscalDocumentRequirement/List";
import BillingEventsWithFiscalDocumentRequirementShow from "./features/billing/pages/EventsWithFiscalDocumentRequirement/Show";
import BillingFiscalDocumentGroupsList from "./features/billing/pages/FiscalDocumentGroups/List";
import BillingFiscalDocumentGroupsShow from "./features/billing/pages/FiscalDocumentGroups/Show";
import BillingBillsShow from "./features/billingBills/pages/Show";
import ReportsPermittedReports from "./features/reports/pages/PermittedReports";
import ReportsSubmit from "./features/reports/pages/Submit";
import NegotiationsList from "./features/negotiations/pages/List";
import NegotiationsCreate from "./features/negotiations/pages/Create";
import NegotiationsShow from "./features/negotiations/pages/Show";
import AccessDenied from "./features/auth/pages/AccessDenied";
import PriceSurveyList from "./features/priceSurvey/pages/List";
import PriceSurveyCreate from "./features/priceSurvey/pages/Create";
import PriceSurveyShow from "./features/priceSurvey/pages/Show";
import { NotFoundPage } from "./common/components/NotFoundErrorMessage";
import GeneralDocumentsList from "./features/generalDocuments/pages/List";
import BankingDepositsList from "./features/bankingDeposits/pages/List";
import BankingDepositsCreate from "./features/bankingDeposits/pages/Create";
import BankingDepositsShow from "./features/bankingDeposits/pages/Show";
import ScrapRulesList from "./features/maintenanceScrapRules/pages/List";
import ScrapRulesCreate from "./features/maintenanceScrapRules/pages/Create";
import ScrapRulesShow from "./features/maintenanceScrapRules/pages/Show";
import ScrapRulesUpdate from "./features/maintenanceScrapRules/pages/Update";
import MaintenanceSolicitationsList from "./features/maintenanceSolicitations/pages/List";
import MaintenanceSolicitationCreate from "./features/maintenanceSolicitations/pages/Create";
import MaintenanceSolicitationShow from "./features/maintenanceSolicitations/pages/Show";
import MaintenanceSolicitationUpdate from "./features/maintenanceSolicitations/pages/Update";
import MaintenanceWorkflowsList from "./features/maintenanceWorkflow/pages/List";
import MaintenanceWorkflowsCreate from "./features/maintenanceWorkflow/pages/Create";
import MaintenanceWorkflowsShow from "./features/maintenanceWorkflow/pages/Show";
import CompanyMaintenanceWorkflowsForwardingsCreate from "./features/maintenanceWorkflow/pages/Show/features/forwardings/pages/Create";
import AnpReportsList from "./features/anpReports/pages/List";
import AnpReportsShow from "./features/anpReports/pages/Show";
import AnpHistoricalReportsList from "./features/anpReports/pages/HistoricalList";
import AnpHistoricalReportsShow from "./features/anpReports/pages/HistoricalShow";
import BranchesCompanyTotalsEquipmentsConsumptionsTotalizer from "./features/movementsTotalizer/pages/BranchesEquipmentsConsumptionsTotalizer";

export const publicRoutes = [
  { path: '/', comp: companyDomain },
  { path: '/recover-company-domain', comp: RecoverCompanyUrl },
  { path: '/access-denied', comp: AccessDenied },
];

export const publicCompanyRoutes = [
  { path: '/login', comp: Login },
  { path: '/reset-password', comp: ResetPassword },
];

export const privateCompanyRoutes = [
  // not found
  { path: '/*', comp: NotFoundPage },

  // general data
  { path: '/company', comp: CompanyDashboard },
  { path: '/company/mine', comp: CompanyProfile },
  { path: '/company/mine/contract', comp: CompanyContract },

  // reports
  { path: '/reports', comp: ReportsPermittedReports },
  { path: '/reports/create', comp: ReportsSubmit },

  // anp reports
  { path: '/anp-reports', comp: AnpReportsList },
  { path: '/anp-reports/:id/*', comp: AnpReportsShow },
  { path: '/anp-historical-reports', comp: AnpHistoricalReportsList },
  { path: '/anp-historical-reports/:id/*', comp: AnpHistoricalReportsShow },

  // company-branches
  { path: '/company-branches', comp: CompanyBranchesStructure },
  { path: '/company-branches/create', comp: CompanyBranchesCreate },
  { path: '/company-branches/:id/edit', comp: CompanyBranchesUpdate },
  { path: '/company-branches/:id/*', comp: CompanyBranchesShow },

  // finacial
  { path: '/billing-events', comp: BillingEventsList },
  { path: '/failed-transactions', comp: FailedConsumptionsList },
  { path: '/movements-totalizer', comp: MovementsTotalizerList },
  { path: '/movements-totalizer/branches-equipments-consumptions-totalizer', comp: BranchesCompanyTotalsEquipmentsConsumptionsTotalizer },
  { path: '/billing-bills', comp: BillingBillsList },
  { path: '/billing-bills/:id/*', comp: BillingBillsShow },

  // establishment
  { path: '/establishments', comp: EstablishmentsMap },
  { path: '/establishments/:id/*', comp: Building },

  // establishment
  { path: '/equipments', comp: EquipmentsList },
  { path: '/equipments/create', comp: EquipmentsCreate },
  { path: '/equipments/:id/edit', comp: EquipmentsUpdate },
  { path: '/equipments/:id/changeHistory/:requestId', comp: EquipmentsChangeHistoryShow },
  { path: '/equipments/:id/*', comp: EquipmentsShow },

  // users
  { path: '/users', comp: UserList },
  { path: '/users/create', comp: UserCreate },
  { path: '/users/:id/edit', comp: UserUpdate },
  { path: '/users/:id/actionsHistory/:requestId', comp: UserActionsHistoryShow },
  { path: '/users/:id/*', comp: UserShow },

  // support
  { path: '/support', comp: SupportList },
  { path: '/support/create', comp: SupportCreate },
  { path: '/support/:id', comp: SupportShow },

  // government allocations
  { path: '/government-allocations', comp: GovernmentAllocationList },
  { path: '/government-allocations/:id/edit', comp: GovernmentAllocationUpdate },
  { path: '/government-allocations/:id/*', comp: GovernmentAllocationShow },

  // supply authorizations
  { path: '/supply-authorizations', comp: SupplyAuthorizationsList },
  { path: '/supply-authorizations/:id', comp: SupplyAuthorizationsShow },

  // events with fiscal document requirement
  { path: '/events-with-fiscal-document-requirement', comp: BillingEventsWithFiscalDocumentRequirementList },
  { path: '/events-with-fiscal-document-requirement/:id', comp: BillingEventsWithFiscalDocumentRequirementShow },

  // fiscal document groups
  { path: '/billing-fiscal-document-groups', comp: BillingFiscalDocumentGroupsList },
  { path: '/billing-fiscal-document-groups/:id', comp: BillingFiscalDocumentGroupsShow },

  // negotiations
  { path: '/negotiations', comp: NegotiationsList },
  { path: '/negotiations/:id', comp: NegotiationsShow },
  { path: '/negotiations/create', comp: NegotiationsCreate },

  // price surveys
  { path: '/price-survey', comp: PriceSurveyList },
  { path: '/price-survey/create', comp: PriceSurveyCreate },
  { path: '/price-survey/:id', comp: PriceSurveyShow },

  // documents
  { path: '/general-documents', comp: GeneralDocumentsList },

  // banking deposits
  { path: '/banking-deposits', comp: BankingDepositsList },
  { path: '/banking-deposits/create', comp: BankingDepositsCreate },
  { path: '/banking-deposits/:id', comp: BankingDepositsShow },

  // scrap rules
  { path: '/maintenance-scrap-rules', comp: ScrapRulesList },
  { path: '/maintenance-scrap-rules/create', comp: ScrapRulesCreate },
  { path: '/maintenance-scrap-rules/:id', comp: ScrapRulesShow },
  { path: '/maintenance-scrap-rules/:id/edit', comp: ScrapRulesUpdate },

  // maintenance solicitations
  { path: '/maintenance-solicitations', comp: MaintenanceSolicitationsList },
  { path: '/maintenance-solicitations/create', comp: MaintenanceSolicitationCreate },
  { path: '/maintenance-solicitations/:id', comp: MaintenanceSolicitationShow },
  { path: '/maintenance-solicitations/:id/edit', comp: MaintenanceSolicitationUpdate },

  // maintenance workflows
  { path: '/maintenance-workflows', comp: MaintenanceWorkflowsList },
  { path: '/maintenance-workflows/create', comp: MaintenanceWorkflowsCreate },
  { path: '/maintenance-workflows/:id', comp: MaintenanceWorkflowsShow },
  { path: '/maintenance-workflows/:id/forwardings/create', comp: CompanyMaintenanceWorkflowsForwardingsCreate },
  { path: '/maintenance-workflows/:id/forwardings/create/:directiveEntryType', comp: CompanyMaintenanceWorkflowsForwardingsCreate },
];
